/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchWorkersDictionaryResponse } from './search-workers-dictionary-response';


export interface SearchWorkersDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchWorkersDictionaryResponse> | null;
}

